/**
 * Paginate data based on opts
 *
 * @param {Array} data Data to be paginated
 * @param {Object<paginationOptions>} pagination Pagination paginationOptions
 * @returns {Object} Object containing page data and count
 */
export default function paginator(data, pagination) {
	const { page, size } = pagination;

	return {
		count: data.length,
		data: data.slice((page - 1) * size, (page - 1) * size + size),
	};
}



// WEBPACK FOOTER //
// ./src/state/helpers/collated/paginator.js